var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"className":"this-page"}},[_c('div',{staticClass:"editor",attrs:{"id":"editor"}}),_c('div',{staticClass:"btn"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.save}},[_vm._v("保存内容")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }